import React from 'react';
import styles from './CardFooter.module.sass';

const CardFooter = ({
    children,
    position
}: Props) => {

    return <div className={`${styles['cardfooter']} ${styles['cardfooter__position--'+(position??'static')]}`}>
        { children }
    </div>
}

interface Props {
    children: any
    position?: 'sticky' | 'static'
}

export default CardFooter;